<template>
  <div id="components-modal-demo-position" ref="infoDialogPdf">
    <a-modal
      v-model="modalVisible"
      centered
      class="modelClose"
      :footer="null"
      :width="740"
      :bodyStyle="bodyStyle"
      @cancel="cancelF"
    >
      <div>
        <a-spin size="large" :spinning="spinning">
          <a-row style="z-index: 9999999">
            <a-col :span="2">
              <img src="@/assets/uploadIcon/pdf.svg" alt="" style="width: 30px; height: 36px" />
            </a-col>
            <a-col :span="21">
              <div>
                <a-row>
                  <a-col :span="24">
                    <div
                      style="
                        margin-top: 4px;
                        font-weight: 700;
                        display: inline;
                        font-size: 18px;
                        font-weight: 800;
                        color: #333333;
                        line-height: 14px;
                      "
                    >
                      {{ data.parseFailedWebDocResultDto.title }}
                    </div>
                  </a-col>
                </a-row>
                <a-row style="margin-top: 9px">
                  <div style="font-size: 14px; font-weight: 500; color: #999999; line-height: 14px">
                    {{ data.parseFailedWebDocResultDto.desc }}
                  </div>
                </a-row>
                <a-row style="margin-top: 29px">
                  <div
                    style="
                      font-size: 12px;

                      font-weight: 400;
                      color: #999999;
                      line-height: 14px;
                      display: inline;
                    "
                  >
                    来源：{{ data.parseFailedWebDocResultDto.source }}
                  </div>
                  <a-divider type="vertical" id="dividerFormat" />
                  <div
                    style="
                      font-size: 12px;

                      font-weight: 400;
                      color: #999999;
                      line-height: 14px;
                      display: inline;
                    "
                  >
                    国家：{{ data.parseResultDetail.countryName }}
                  </div>
                  <a-divider type="vertical" id="dividerFormat" />
                  <div
                    style="
                      font-size: 12px;

                      font-weight: 400;
                      color: #999999;
                      line-height: 14px;
                      display: inline;
                    "
                  >
                    语言：{{ data.parseResultDetail.langName }}
                  </div>
                  <a-divider type="vertical" id="dividerFormat" />
                  <div
                    style="
                      font-size: 12px;

                      font-weight: 400;
                      color: #999999;
                      line-height: 14px;
                      display: inline;
                    "
                  >
                    发布时间：{{ data.parseFailedWebDocResultDto.publishTime }}
                  </div>
                </a-row>
              </div>
            </a-col>
          </a-row>
          <a-row>
            <a-col>
              <div v-for="i in pageNum" :key="i">
                <pdf
                  ref="pdf"
                  :src="pdfUrl"
                  :page="i"
                  :rotate="pageRotate"
                  @num-pages="pageTotalNum = $event"
                >
                </pdf>
              </div>
            </a-col>
          </a-row>
          <!-- <button class="btn-def btn-pre" @click.stop="clock">顺时针</button>
        <button class="btn-def btn-next" @click.stop="counterClock">逆时针</button> -->
          <!-- <button class="btn-def btn-pre" @click.stop="prePage">上一页</button>
          <button class="btn-def btn-next" @click.stop="nextPage">下一页</button>
          <div>{{ pageNum }}/{{ pageTotalNum }}</div> -->
          <!-- <button :class="{ select: idx == 0 }" @touchstart="idx = 0" @touchend="idx = -1" @click="scaleD">放大</button>
        <button :class="{ select: idx == 1 }" @touchstart="idx = 1" @touchend="idx = -1" @click="scaleX">缩小</button>
        <button @click="fileDownload(pdfUrl, 'pdf文件')">下载</button>
        <div>进度：{{ loadedRatio }}</div>
        <div>页面加载成功: {{ curPageNum }}</div> -->
        </a-spin>
      </div>
    </a-modal>
  </div>
</template>
<script>
import pdf from 'vue-pdf'
import { message } from 'ant-design-vue'
export default {
  components: {
    pdf
  },
  data() {
    return {
      modalVisible: false,
      pdfUrl: '',
      pageNum: 1,
      pageTotalNum: 0,
      spinning: false,
      pageRotate: 0,
      loadedRatio: 0, // 加载进度
      curPageNum: 0,
      scale: 100, // 放大系数
      idx: -1,
      bodyStyle: {
        height: '800px',
        overflow: 'auto'
      },
      data: { parseResultDetail: {} }
    }
  },
  created() {},
  watch: {
    pageTotalNum(val, oldVal) {
      //普通的watch监听
      if (val) {
        this.pageNum = val
      }
    }
  },
  methods: {
    cancelF() {
      this.pdfUrl = ''
      this.pageTotalNum = 0
    },
    openModel(data) {
      this.pdfUrl = data.parseFailedWebDocResultDto.urlHdfsPath
      this.data = data
      this.spinning = true
      this.modalVisible = true
      this.pageNum = 1
      setTimeout(() => {
        this.spinning = false
        this.$nextTick(() => {
          const container = this.$refs.infoDialogPdf
          container.scrollTop = container.scrollHeight
        })
      }, 800)
    },
    // 下载PDF
    fileDownload(data, fileName) {
      const blob = new Blob([data], {
        // type类型后端返回来的数据中会有，根据自己实际进行修改
        type: 'application/pdf;charset-UTF-8'
      })
      const filename = fileName || '报表.xls'
      if (typeof window.navigator.msSaveBlob !== 'undefined') {
        window.navigator.msSaveBlob(blob, filename)
      } else {
        var blobURL = window.URL.createObjectURL(blob)
        // 创建隐藏<a>标签进行下载
        var tempLink = document.createElement('a')
        tempLink.style.display = 'none'
        tempLink.href = blobURL
        tempLink.setAttribute('download', filename)
        if (typeof tempLink.download === 'undefined') {
          tempLink.setAttribute('target', '_blank')
        }
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
        window.URL.revokeObjectURL(blobURL)
      }
    },
    // 放大
    scaleD() {
      this.scale += 5
      this.$refs.pdf.$el.style.width = parseInt(this.scale) + '%'
    },

    // 缩小
    scaleX() {
      if (this.scale === 100) {
        return
      }
      this.scale += -5
      this.$refs.pdf.$el.style.width = parseInt(this.scale) + '%'
    },
    prePage() {
      var p = this.pageNum
      if (p === 1) {
        message.error('已经浏览到第一页')
        return false
      }
      p = p > 1 ? p - 1 : this.pageTotalNum
      this.pageNum = p
    },
    nextPage() {
      var p = this.pageNum
      if (p === this.pageTotalNum) {
        message.error('已经浏览到最后一页')
        return false
      }
      p = p < this.pageTotalNum ? p + 1 : 1
      this.pageNum = p
    },
    clock() {
      this.pageRotate += 90
    },
    counterClock() {
      this.pageRotate -= 90
    },
    password(updatePassword, reason) {
      updatePassword(prompt('password is "123456"'))
    },
    pageLoaded(e) {
      this.curPageNum = e
    },
    pdfError(error) {
      console.error(error)
    },
    pdfPrintAll() {
      this.$refs.pdf.print()
    },
    pdfPrint() {
      this.$refs.pdf.print(100, [1, 2])
    }
  }
}
</script>
<style scoped>
.modelClose /deep/ .ant-modal-footer {
  text-align: center;
  padding: 20px 16px;
}
.modelClose /deep/ .ant-modal-footer button + button {
  margin-left: 30px;
}
.formFormat /deep/ .ant-form-item {
  margin-bottom: 20px;
  padding-bottom: 0px !important;
}
</style>
